// extracted by mini-css-extract-plugin
export default {"modal__close":"CloseModalButton_modal__close__IoIal"};